// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"3396dfb1","787":"edcbbaa2"}[chunkId] + ".chunk.js";
};